// /* eslint-disable */
// import React from "react";
// import {
//   Chart as ChartJS,
//   CategoryScale,
//   LinearScale,
//   BarElement,
//   Title,
//   Tooltip,
//   Legend
// } from "chart.js";
// import { Bar } from "react-chartjs-2";

// ChartJS.register(
//   CategoryScale,
//   LinearScale,
//   BarElement,
//   Title,
//   Tooltip,
//   Legend
// );

// const EntityStatusComparisonChart = ({
//   labels = [],
//   actualFTEs = [],
//   budgetedFTEs = [],
//   title = "Entity Status Comparison"
// }) => {
//   const data = {
//     labels,
//     datasets: [
//       {
//         label: "Actual FTEs",
//         data: actualFTEs,
//         backgroundColor: "#1f77b4",
//         stack: "stack1"
//       },
//       {
//         label: "Budgeted FTEs",
//         data: budgetedFTEs,
//         backgroundColor: "#ff7f0e",
//         stack: "stack1"
//       }
//     ]
//   };

//   const options = {
//     responsive: true,
//     maintainAspectRatio: false,
//     plugins: {
//       legend: {
//         position: "bottom"
//       },
//       title: {
//         display: true,
//         text: title,
//         font: { size: 18 }
//       }
//     },
//     scales: {
//       x: {
//         stacked: true,
//         title: {
//           display: true,
//           text: "TMLPV"
//         }
//       },
//       y: {
//         stacked: false,
//         beginAtZero: true,
//         max: 100,
//         title: {
//           display: true,
//           text: "FTE Count"
//         }
//       }
//     }
//   };

//   return (
//     <div style={{ height: "400px", width: "100%" }}>
//       <Bar data={data} options={options} />
//     </div>
//   );
// };

// export default EntityStatusComparisonChart;


/* eslint-disable */
import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
} from "chart.js";
import { Bar } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const EntityStatusComparisonChart = ({
  labels = [],
  actualFTEs = [],
  budgetedFTEs = [],
  title = "Entity Status Comparison",
  heightValues = "400px"
}) => {
  const data = {
    labels,
    datasets: [
      actualFTEs,
      budgetedFTEs,

    ]
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "bottom",
        usePointStyle: true,
        pointStyle: "circle",
        boxWidth: 12,
        boxHeight: 12,
        padding: 14,
        font: { size: 12 },
      },
      title: {
        display: true,
        // text: title,
        // text: `${title} Status Comparison`,
        font: { size: 10 }
      },
      datalabels: {
        color: "#000",
        anchor: "end",
        align: "top",
        offset: 10,       // Increased space to accommodate the tilt
        rotation: -45,    // Tilted 45 degrees (use -45 for left-tilt or 45 for right-tilt)
        font: {
          weight: "bold",
          size: 10,        // Increased slightly from 6 for readability, but keep it small if needed
        },
        formatter: (value) => value,
      },
    },
    scales: {
      x: {
        stacked: false,
        // title: {
        //   display: true,
        //   text: "TMLPV"
        // }
      },
      y: {
        // stacked: false,
        beginAtZero: true,
        // title: {
        //   display: true,
        //   text: "FTE Count"
        // }
      }
    }
  };

  return (
    <div style={{ height: heightValues, width: "100%", marginBottom: "30px" }}>
      <div className="d-flex justify-content-center align-items-center">
        <b style={{ fontSize: '12px' }}>{title} Status Comparison</b>
      </div>
      {/* <div style={{margin:"2px"}}> */}
      <Bar data={data} options={options} />
      {/* </div> */}
    </div>
  );
};

export default EntityStatusComparisonChart;
